// SectionLoading — production loading placeholder for sections whose analysis
// is still in flight (state === "pending"). Therapists see this; distinct from
// MissingMappedData which is dev-only. DS §4.9.

export interface SectionLoadingProps {
    label?: string;
    className?: string;
}

export function SectionLoading({ label = "Analysing…", className }: SectionLoadingProps) {
    return (
        <div
            data-testid="section-loading"
            role="status"
            aria-live="polite"
            className={
                "flex items-center gap-2 rounded-md border border-[var(--hairline,rgba(0,0,0,0.08))] " +
                "bg-[var(--bg-rail,rgba(0,0,0,0.03))] px-4 py-2 text-sm " +
                "text-[var(--ink-soft,rgba(0,0,0,0.6))] " +
                (className ?? "")
            }
        >
            <span
                aria-hidden
                className="inline-block h-2 w-2 animate-pulse rounded-full bg-[var(--interactive)]"
            />
            <span>{label}</span>
        </div>
    );
}
